import PropTypes from 'prop-types';
import { Box, Divider, IconButton, Typography } from '@mui/material';
// project import
import { styled, useTheme } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';

const DrawerBottomHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    justifyContent: 'flex-start',
}));

const DrawerBottom = ({
    open = false,
    openRightDrawer,
    rightDrawerWidth = 0,
    onDrawer = () => {},
    children,
}) => {
    const theme = useTheme();

    const handleDrawer = () => {
        onDrawer(!open);
    };

    return (
        <>
            <DrawerBottomHeader
                sx={{
                    display: !open ? 'flex' : 'none',
                    border: `1px solid ${theme.palette.divider}`,
                    borderRadius: '4px',
                }}
            >
                <Typography
                    variant="h6"
                    noWrap
                    sx={{
                        marginLeft: '12px',
                        flexGrow: 1,
                    }}
                    component="div"
                >
                    Commands
                </Typography>
                <IconButton onClick={handleDrawer}>
                    {theme.direction === 'rtl' ? (
                        <KeyboardDoubleArrowDownIcon />
                    ) : (
                        <KeyboardDoubleArrowUpIcon />
                    )}
                </IconButton>
            </DrawerBottomHeader>
            <Drawer
                sx={{
                    width: `calc(100% - ${
                        !openRightDrawer ? 0 : rightDrawerWidth
                    }px)`,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: `calc(100% - ${
                            !openRightDrawer ? 0 : rightDrawerWidth
                        }px)`,
                    },
                }}
                variant="persistent"
                anchor="bottom"
                open={open}
            >
                <DrawerBottomHeader
                    sx={{
                        display: open ? 'flex' : 'none',
                        padding: '0 24px',
                        margin: 0,
                    }}
                >
                    <Typography
                        variant="h6"
                        noWrap
                        sx={{ flexGrow: 1 }}
                        component="div"
                    >
                        Commands
                    </Typography>
                    <IconButton onClick={handleDrawer}>
                        {theme.direction === 'rtl' ? (
                            <KeyboardDoubleArrowUpIcon />
                        ) : (
                            <KeyboardDoubleArrowDownIcon />
                        )}
                    </IconButton>
                </DrawerBottomHeader>
                <Divider />
                <Box> {children}</Box>
            </Drawer>
        </>
    );
};

DrawerBottom.propTypes = {
    open: PropTypes.bool,
    openRightDrawer: PropTypes.bool,
    rightDrawerWidth: PropTypes.number,
    onDrawer: PropTypes.func,
    children: PropTypes.node,
};

export default DrawerBottom;
